import axios from "axios";

const state = {
    cal: {},
    events: []

};

const getters = {
    events: state => {
        return state.events
    }

};

const actions = {
    appointment({}, cal) {
        console.log(cal.startTime);
        const moment = require('moment')
        const startDateStr = moment(cal.startTime).utc().format('YYYY-MM-DD HH:mm:ss ')
        const endDateStr = moment(cal.endTime).utc().format('YYYY-MM-DD HH:mm:ss ')
        console.log(startDateStr);

        axios.post("/api/savemeeting", {
                startTime: startDateStr,
                endTime: endDateStr,
                title: cal.title,
                content: cal.content,
                class: cal.class
            })
            .then(response => {

                console.log(response.data);
            }).catch(function (error) {
                console.log(error);
            });
    },

    fetchAppointments({
        commit
    }) {
        axios.get('/api/getmeeting')
            .then(response => {

                var data = response.data;
                var i = 0;
                for (i; i < response.data.length; i++) {
                    const moment = require('moment')
                    var startUtc = moment.utc(data[i].start).toDate();
                    var endUtc = moment.utc(data[i].end).toDate();
                    data[i].start = moment(startUtc).local().format('YYYY-MM-DD HH:mm:ss');
                    data[i].end = moment(endUtc).local().format('YYYY-MM-DD HH:mm:ss');
                }
                commit('FETCH_APPOINTMENTS', data)
            }).catch(err => {
                console.log(err)
            })
    },
    deleteAppointments({commit}, event) {
        axios.delete('/api/deletemeeting/'+event.id)
            .then(res => {
                if (res.data === 'ok')
                    commit('DELETE_APPOINTMENTS', event)
            }).catch(err => {
            console.log(err)
        })
    }

};

const mutations = {
    FETCH_APPOINTMENTS(state, events) {
        return state.events = events
    },
    DELETE_APPOINTMENTS(state, event) {
        let index = state.event.findIndex(item => item.id === event.id)
        state.event.splice(index, 1)
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
